import { render, staticRenderFns } from "./ReportBulkGenerator.vue?vue&type=template&id=3c48e620&scoped=true&"
import script from "./ReportBulkGenerator.vue?vue&type=script&lang=js&"
export * from "./ReportBulkGenerator.vue?vue&type=script&lang=js&"
import style0 from "./ReportBulkGenerator.vue?vue&type=style&index=0&id=3c48e620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48e620",
  null
  
)

export default component.exports